import React, { useState, Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './navbar.css'

const Navbar = (props) => {
  const [activeDropdown, setActiveDropdown] = useState('none')
  return (
    <nav className={`navbar-container10 ${props.rootClassName} `}>
      <div className="navbar-container11 column align-center full-width background-glass-effect">
        <header data-thq="thq-navbar" className="navbar-navbar-interactive">
          <Link to="/" className="navbar-navlink1">
            <img
              alt="Odynn Logo"
              sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
              src="/Pages/Home/pastedimage-azfl-1500h.webp"
              srcSet="/Pages/Home//pastedimage-azfl-1500h.webp 1200w, /Pages/Home/pastedimage-azfl-tablet.webp 800w, /Pages/Home/pastedimage-azfl-mobile.webp 480w"
              className="navbar-image1"
            />
          </Link>
          <div data-thq="thq-navbar-nav" className="navbar-desktop-menu">
            <nav className="navbar-links1">
              <div
                onClick={() => setActiveDropdown('home')}
                className="navbar-home1 row align-center"
              >
                <span
                  className={`navbar-link10 thq-link navbar-link ${
                    activeDropdown === 'home' ? 'dropdown-open' : ''
                  } `}
                >
                  Home
                </span>
                <svg
                  viewBox="0 0 1024 1024"
                  className={`dropdown-icon ${
                    activeDropdown === 'home' ? 'icon-open' : ''
                  } ${activeDropdown !== 'home' ? 'icon-closed' : ''} `}
                >
                  <path d="M426 726v-428l214 214z"></path>
                </svg>
              </div>
              <div
                onClick={() => setActiveDropdown('about')}
                className="navbar-about1 row align-center"
              >
                <span
                  className={`navbar-link11 thq-link navbar-link ${
                    activeDropdown === 'about' ? 'dropdown-open' : ''
                  } `}
                >
                  About Us
                </span>
                <svg
                  viewBox="0 0 1024 1024"
                  className={`dropdown-icon ${
                    activeDropdown === 'about' ? 'icon-open' : ''
                  } ${activeDropdown !== 'about' ? 'icon-closed' : ''} `}
                >
                  <path d="M426 726v-428l214 214z"></path>
                </svg>
              </div>
              <div
                onClick={() => setActiveDropdown('support')}
                className="navbar-support1 row align-center"
              >
                <span
                  className={`navbar-link12 thq-link navbar-link ${
                    activeDropdown === 'support' ? 'dropdown-open' : ''
                  } `}
                >
                  Support
                </span>
                <svg
                  viewBox="0 0 1024 1024"
                  className={`dropdown-icon ${
                    activeDropdown === 'support' ? 'icon-open' : ''
                  } ${activeDropdown !== 'support' ? 'icon-closed' : ''} `}
                >
                  <path d="M426 726v-428l214 214z"></path>
                </svg>
              </div>
              <div
                onClick={() => setActiveDropdown('charging')}
                className="navbar-charging-points1 row align-center"
              >
                <span
                  className={`navbar-link13 thq-link navbar-link ${
                    activeDropdown === 'charging' ? 'dropdown-open' : ''
                  } `}
                >
                  Charging Points
                </span>
                <svg
                  viewBox="0 0 1024 1024"
                  className={`dropdown-icon ${
                    activeDropdown === 'charging' ? 'icon-open' : ''
                  } ${activeDropdown !== 'charging' ? 'icon-closed' : ''} `}
                >
                  <path d="M426 726v-428l214 214z"></path>
                </svg>
              </div>
            </nav>
          </div>
          <div data-thq="thq-burger-menu" className="navbar-burger-menu">
            <svg viewBox="0 0 1024 1024" className="navbar-icon18">
              <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
            </svg>
          </div>
          <div data-thq="thq-mobile-menu" className="navbar-mobile-menu">
            <div className="navbar-nav">
              <div className="navbar-top">
                <Link to="/" className="navbar-navlink2">
                  <img
                    alt="image"
                    sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                    src="/Pages/Home/pastedimage-azfl-1500h.webp"
                    srcSet="/Pages/Home//pastedimage-azfl-1500h.webp 1200w, /Pages/Home/pastedimage-azfl-tablet.webp 800w, /Pages/Home/pastedimage-azfl-mobile.webp 480w"
                    className="navbar-image2"
                  />
                </Link>
                <div data-thq="thq-close-menu" className="navbar-close-menu">
                  <svg viewBox="0 0 1024 1024" className="navbar-icon20">
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <nav className="navbar-links2">
                <div data-thq="accordion" className="navbar-home2">
                  <details
                    name="mobileMenu"
                    data-thq="accordion-trigger"
                    className="navbar-trigger1"
                  >
                    <summary
                      data-thq="accordion-summary"
                      className="navbar-summary1"
                    >
                      <span className="thq-link navbar-link navbar-link14">
                        Home
                      </span>
                      <div
                        data-thq="accordion-icon"
                        className="navbar-icon-container1"
                      >
                        <svg width="32" height="32" viewBox="0 0 24 24">
                          <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                        </svg>
                      </div>
                    </summary>
                  </details>
                  <div data-thq="accordion-content">
                    <div className="column gap-1-5 navbar-container12">
                      <a href={props.homeLink1Url} className="navbar-font">
                        {props.homeLink1 ?? (
                          <Fragment>
                            <span className="navbar-text13">
                              View real-time charger availability, monitor your
                              charging sessions, and more
                            </span>
                          </Fragment>
                        )}
                      </a>
                      <a href={props.homeLink2Url} className="navbar-font">
                        {props.homeLink2 ?? (
                          <Fragment>
                            <span className="navbar-text19">
                              Discover one of the nation&apos;s largest public
                              fast charging networks, powered by 100% renewable
                              energy
                            </span>
                          </Fragment>
                        )}
                      </a>
                      <a href={props.homeLink3Url} className="navbar-font">
                        {props.homeLink3 ?? (
                          <Fragment>
                            <span className="navbar-text20">How to Charge</span>
                          </Fragment>
                        )}
                      </a>
                      <a href={props.homeLink4Url} className="navbar-font">
                        {props.homeLink4 ?? (
                          <Fragment>
                            <span className="navbar-text11">
                              Learn how to power up on the go and review our
                              charging FAQs.
                            </span>
                          </Fragment>
                        )}
                      </a>
                      <a href={props.homeLink5Url} className="navbar-font">
                        {props.homeLink5 ?? (
                          <Fragment>
                            <span className="navbar-text23">
                              Can&apos;t find what you&apos;re looking for? Let
                              us help you.
                            </span>
                          </Fragment>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
                <div data-thq="accordion" className="navbar-about2">
                  <details
                    name="mobileMenu"
                    data-thq="accordion-trigger"
                    className="navbar-trigger2"
                  >
                    <summary
                      data-thq="accordion-summary"
                      className="navbar-summary2"
                    >
                      <span className="thq-link navbar-link">About Us</span>
                      <div
                        data-thq="accordion-icon"
                        className="navbar-icon-container2"
                      >
                        <svg width="32" height="32" viewBox="0 0 24 24">
                          <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                        </svg>
                      </div>
                    </summary>
                  </details>
                  <div data-thq="accordion-content" className="column gap-0-5">
                    <div className="column gap-1-5 navbar-container13">
                      <a
                        href={props.aboutLink1Url}
                        className="navbar-font navbar-link20"
                      >
                        {props.aboutLink1 ?? (
                          <Fragment>
                            <span className="navbar-text10">
                              From recycling to renewable energy, we&apos;re
                              committed to protecting our environment.
                            </span>
                          </Fragment>
                        )}
                      </a>
                      <a href={props.aboutLink2Url} className="navbar-font">
                        {props.aboutLink2 ?? (
                          <Fragment>
                            <span className="navbar-text14">
                              Cultivating Connection
                            </span>
                          </Fragment>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
                <div data-thq="accordion" className="navbar-support2">
                  <details
                    name="mobileMenu"
                    data-thq="accordion-trigger"
                    className="navbar-trigger3"
                  >
                    <summary
                      data-thq="accordion-summary"
                      className="navbar-summary3"
                    >
                      <span className="thq-link navbar-link">Support</span>
                      <div
                        data-thq="accordion-icon"
                        className="navbar-icon-container3"
                      >
                        <svg width="32" height="32" viewBox="0 0 24 24">
                          <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                        </svg>
                      </div>
                    </summary>
                  </details>
                  <div data-thq="accordion-content" className="column gap-0-5">
                    <div className="column gap-1-5 navbar-container14">
                      <a href={props.supportLink1Url} className="navbar-font">
                        {props.supportLink1 ?? (
                          <Fragment>
                            <span className="navbar-text15">
                              <span>
                                Whether you&apos;re a dedicated public charger
                                or want to keep your options open,
                              </span>
                              <br></br>
                              <span> iCharge has a plan for you.</span>
                            </span>
                          </Fragment>
                        )}
                      </a>
                      <a href={props.supportLink2Url} className="navbar-font">
                        {props.supportLink2 ?? (
                          <Fragment>
                            <span className="navbar-text22">How to charge</span>
                          </Fragment>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
                <div data-thq="accordion" className="navbar-charging-points2">
                  <details
                    name="mobileMenu"
                    data-thq="accordion-trigger"
                    className="navbar-trigger4"
                  >
                    <summary
                      data-thq="accordion-summary"
                      className="navbar-summary4"
                    >
                      <span className="thq-link navbar-link">
                        Charging Points
                      </span>
                      <div
                        data-thq="accordion-icon"
                        className="navbar-icon-container4"
                      >
                        <svg width="32" height="32" viewBox="0 0 24 24">
                          <path d="m12 14l-4-4h8z" fill="currentColor"></path>
                        </svg>
                      </div>
                    </summary>
                  </details>
                  <div data-thq="accordion-content" className="column gap-0-5">
                    <div className="column gap-1-5 navbar-container15">
                      <a
                        href={props.chargingPointLink1Url}
                        className="navbar-font"
                      >
                        {props.chargingPointLink1 ?? (
                          <Fragment>
                            <span className="navbar-text12">
                              Can&apos;t find what you&apos;re looking for? Let
                              us help you
                            </span>
                          </Fragment>
                        )}
                      </a>
                      <a
                        href={props.chargingPointLink2Url}
                        className="navbar-font"
                      >
                        {props.chargingPointLink2 ?? (
                          <Fragment>
                            <span className="navbar-text21">
                              Locate nearby charging points with the iCharge app
                              and simplify your charging
                            </span>
                          </Fragment>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </header>
      </div>
      <div className="full-width dropdown-content-wrapper">
        {activeDropdown === 'home' && (
          <div className="navbar-home3 column align-center justify-center full-width dropdown-content-container background-glass-effect">
            <div className="navbar-max-width1 row full-width max-content-width">
              <div className="navbar-container16 row flex-1 dropdown-links-wrapper">
                <a
                  href={props.homeLink1Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.homeLink1 ?? (
                    <Fragment>
                      <span className="navbar-text13">
                        View real-time charger availability, monitor your
                        charging sessions, and more
                      </span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.homeLink2Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.homeLink2 ?? (
                    <Fragment>
                      <span className="navbar-text19">
                        Discover one of the nation&apos;s largest public fast
                        charging networks, powered by 100% renewable energy
                      </span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.homeLink3Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.homeLink3 ?? (
                    <Fragment>
                      <span className="navbar-text20">How to Charge</span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.homeLink4Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.homeLink4 ?? (
                    <Fragment>
                      <span className="navbar-text11">
                        Learn how to power up on the go and review our charging
                        FAQs.
                      </span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.homeLink5Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.homeLink5 ?? (
                    <Fragment>
                      <span className="navbar-text23">
                        Can&apos;t find what you&apos;re looking for? Let us
                        help you.
                      </span>
                    </Fragment>
                  )}
                </a>
              </div>
            </div>
          </div>
        )}
        {activeDropdown === 'about' && (
          <div className="navbar-about3 column align-center justify-center full-width dropdown-content-container background-glass-effect">
            <div className="navbar-max-width2 row full-width max-content-width">
              <div className="navbar-container17 row flex-1 dropdown-links-wrapper">
                <a
                  href={props.aboutLink1Url}
                  className="navbar-dropdown-link navbar-font navbar-about-link1"
                >
                  {props.aboutLink1 ?? (
                    <Fragment>
                      <span className="navbar-text10">
                        From recycling to renewable energy, we&apos;re committed
                        to protecting our environment.
                      </span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.aboutLink2Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.aboutLink2 ?? (
                    <Fragment>
                      <span className="navbar-text14">
                        Cultivating Connection
                      </span>
                    </Fragment>
                  )}
                </a>
              </div>
            </div>
          </div>
        )}
        {activeDropdown === 'support' && (
          <div className="navbar-support3 column align-center justify-center full-width dropdown-content-container background-glass-effect">
            <div className="navbar-max-width3 row full-width max-content-width">
              <div className="navbar-container18 row flex-1 dropdown-links-wrapper">
                <a
                  href={props.supportLink1Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.supportLink1 ?? (
                    <Fragment>
                      <span className="navbar-text15">
                        <span>
                          Whether you&apos;re a dedicated public charger or want
                          to keep your options open,
                        </span>
                        <br></br>
                        <span> iCharge has a plan for you.</span>
                      </span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.supportLink2Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.supportLink2 ?? (
                    <Fragment>
                      <span className="navbar-text22">How to charge</span>
                    </Fragment>
                  )}
                </a>
              </div>
            </div>
          </div>
        )}
        {activeDropdown === 'charging' && (
          <div className="navbar-charging-points3 column align-center justify-center full-width dropdown-content-container background-glass-effect">
            <div className="navbar-max-width4 row full-width max-content-width">
              <div className="navbar-container19 row flex-1 dropdown-links-wrapper">
                <a
                  href={props.chargingPointLink1Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.chargingPointLink1 ?? (
                    <Fragment>
                      <span className="navbar-text12">
                        Can&apos;t find what you&apos;re looking for? Let us
                        help you
                      </span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.chargingPointLink2Url}
                  className="navbar-dropdown-link navbar-font thq-link"
                >
                  {props.chargingPointLink2 ?? (
                    <Fragment>
                      <span className="navbar-text21">
                        Locate nearby charging points with the iCharge app and
                        simplify your charging
                      </span>
                    </Fragment>
                  )}
                </a>
              </div>
            </div>
          </div>
        )}
        <div
          onClick={() => setActiveDropdown('none')}
          className={`full-width ${
            activeDropdown !== 'none' ? 'full-vertical-height' : ''
          } `}
        ></div>
      </div>
    </nav>
  )
}

Navbar.defaultProps = {
  aboutLink1: undefined,
  homeLink4: undefined,
  chargingPointLink1Url: '/help-center',
  homeLink2Url: 'https://m.icharge.app/#/homepage',
  rootClassName: '',
  chargingPointLink2Url: 'https://m.icharge.app/#/homepage',
  chargingPointLink1: undefined,
  homeLink1: undefined,
  homeLink1Url: 'https://apps.apple.com/us/app/icharge-app/id6479523452',
  aboutLink2: undefined,
  homeLink5Url: '/help-center',
  supportLink1: undefined,
  homeLink4Url: '/#faq',
  homeLink2: undefined,
  homeLink3: undefined,
  chargingPointLink2: undefined,
  homeLink3Url: '/#steps',
  supportLink2Url: '/#steps',
  supportLink1Url: '/help-center',
  aboutLink1Url: '',
  supportLink2: undefined,
  aboutLink2Url: '/services',
  homeLink5: undefined,
}

Navbar.propTypes = {
  aboutLink1: PropTypes.element,
  homeLink4: PropTypes.element,
  chargingPointLink1Url: PropTypes.string,
  homeLink2Url: PropTypes.string,
  rootClassName: PropTypes.string,
  chargingPointLink2Url: PropTypes.string,
  chargingPointLink1: PropTypes.element,
  homeLink1: PropTypes.element,
  homeLink1Url: PropTypes.string,
  aboutLink2: PropTypes.element,
  homeLink5Url: PropTypes.string,
  supportLink1: PropTypes.element,
  homeLink4Url: PropTypes.string,
  homeLink2: PropTypes.element,
  homeLink3: PropTypes.element,
  chargingPointLink2: PropTypes.element,
  homeLink3Url: PropTypes.string,
  supportLink2Url: PropTypes.string,
  supportLink1Url: PropTypes.string,
  aboutLink1Url: PropTypes.string,
  supportLink2: PropTypes.element,
  aboutLink2Url: PropTypes.string,
  homeLink5: PropTypes.element,
}

export default Navbar
